// extracted by mini-css-extract-plugin
module.exports = {"button":"CheckoutButton_button__d9H7N"};